import Highcharts from 'highcharts';

type ChartWithGetSVG = {
  getSVG: () => string;
} & Highcharts.Chart;

export const getChartSVG = (
  chartId: string,
  chartOptions: Highcharts.Options,
  containerStyle: string
): string => {
  try {
    const chartContainer = document.createElement('div');

    chartContainer.setAttribute('style', `${containerStyle} display: none;`);
    chartContainer.setAttribute('id', `chart-${chartId}`);

    document.body.append(chartContainer);

    const chart = Highcharts.chart(`chart-${chartId}`, chartOptions);

    chartContainer.remove();

    return (chart as ChartWithGetSVG).getSVG();
  } catch (error) {
    console.error('Unable to generate chart SVG', error);
    return '';
  }
};
